import { render, staticRenderFns } from "./MsComboBoxItemV2.vue?vue&type=template&id=1912ade8&scoped=true"
import script from "./MsComboBoxItemV2.vue?vue&type=script&lang=js"
export * from "./MsComboBoxItemV2.vue?vue&type=script&lang=js"
import style0 from "./MsComboBoxItemV2.vue?vue&type=style&index=0&id=1912ade8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1912ade8",
  null
  
)

export default component.exports